export const adaptCuidadosPaliativosRI = ({ cuidadosPaliativosRIByDatosGeneralesId }) => {
    const { cuidadosPaliativosRI, estudioAdjunto, directivasAdjunto, videodeglucionAdjunto } = cuidadosPaliativosRIByDatosGeneralesId;
    return {
        idDatosGeneralesRI: cuidadosPaliativosRI?.idDatosGeneralesRI,
        cuidadosPaliativos1: {
            idCuidadosPaliativosRI: cuidadosPaliativosRI?.idCuidadosPaliativosRI,
            directivasAnticipadas: cuidadosPaliativosRI?.directivasAnticipadas,
            directivasAdjunto: !!directivasAdjunto?.contentType ? {
                contentType: directivasAdjunto?.contentType,
                titulo: directivasAdjunto?.titulo,
                archivo: directivasAdjunto?.archivo,
                extension: directivasAdjunto?.extension
            } : null,
            religion: cuidadosPaliativosRI?.religion,
            pasatiempo: cuidadosPaliativosRI?.pasatiempo,
            profesionOcupacion: cuidadosPaliativosRI?.profesionOcupacion,
            cuidadorPrincipal: cuidadosPaliativosRI?.cuidadorPrincipal,
            medicoCabecera: cuidadosPaliativosRI?.medicoCabecera,
            estudioAdjunto: estudioAdjunto.map((estudio) => {
                return {
                    contentType: estudio?.contentType,
                    titulo: estudio?.titulo,
                    archivo: estudio?.archivo,
                    extension: estudio?.extension
                }
            }),
            otrosEstudios: cuidadosPaliativosRI?.otrosEstudios,
            idComboRIValorECOG: cuidadosPaliativosRI?.idComboRIValorECOG,
            idComboRIValorTabaquismo: cuidadosPaliativosRI?.idComboRIValorTabaquismo,
            antecedenteAlcoholismo: cuidadosPaliativosRI?.antecedenteAlcoholismo,
            antecedenteConsumoSustancias: cuidadosPaliativosRI?.antecedenteConsumoSustancias,
            descSustancia: cuidadosPaliativosRI?.descSustancia,
        },
        cuidadosPaliativos2: {
            idCuidadosPaliativosRI: cuidadosPaliativosRI?.idCuidadosPaliativosRI,
            tensionArterial: cuidadosPaliativosRI?.tensionArterial,
            frecCardiaca: cuidadosPaliativosRI?.frecCardiaca,
            frecRespiratoria: cuidadosPaliativosRI?.frecRespiratoria,
            temperatura: cuidadosPaliativosRI?.temperatura,
            pielMucosasFaneras: cuidadosPaliativosRI?.pielMucosasFaneras,
            sNC: cuidadosPaliativosRI?.sNC,
            cV: cuidadosPaliativosRI?.cV,
            respiratorio: cuidadosPaliativosRI?.respiratorio,
            digestivo: cuidadosPaliativosRI?.digestivo,
            videodeglucion: cuidadosPaliativosRI?.videodeglucion,
            videodeglucionAdjunto: {
                contentType: videodeglucionAdjunto?.contentType,
                archivo: videodeglucionAdjunto?.archivo,
                extension: videodeglucionAdjunto?.extension,
                titulo: videodeglucionAdjunto?.titulo,
            },
            otros: cuidadosPaliativosRI?.otros,
            sondaVesical: cuidadosPaliativosRI?.sondaVesical,
            cateter: cuidadosPaliativosRI?.cateter,
            sondaNasogastrica: cuidadosPaliativosRI?.sondaNasogastrica,
            soporteNutricional: cuidadosPaliativosRI?.soporteNutricional,
            aduESAS: cuidadosPaliativosRI?.aduESAS,
            dolor: cuidadosPaliativosRI?.dolor,
            disnea: cuidadosPaliativosRI?.disnea,
            nauseas: cuidadosPaliativosRI?.nauseas,
            depresion: cuidadosPaliativosRI?.depresion,
            ansiedad: cuidadosPaliativosRI?.ansiedad,
            anorexia: cuidadosPaliativosRI?.anorexia,
            bienestar: cuidadosPaliativosRI?.bienestar,
            cansancio: cuidadosPaliativosRI?.cansancio,
            insomnio: cuidadosPaliativosRI?.insomnio,
            somnolencia: cuidadosPaliativosRI?.somnolencia,
            constipacion: cuidadosPaliativosRI?.constipacion,
            resultadoAduESAS: cuidadosPaliativosRI?.resultadoAduESAS,
            idComboRIValorPedLANSKY: cuidadosPaliativosRI?.idComboRIValorPedLANSKY,
            pedGMFS: cuidadosPaliativosRI?.pedGMFS,
            resultadoPedGMFS: cuidadosPaliativosRI?.resultadoPedGMFS,
            idComboRIValorPedEscalaDolor: cuidadosPaliativosRI?.idComboRIValorPedEscalaDolor,
            pedFLACCR: cuidadosPaliativosRI?.pedFLACCR,
            resultadoPedFLACCR: cuidadosPaliativosRI?.resultadoPedFLACCR,
            pedGustaveRoussy: cuidadosPaliativosRI?.pedGustaveRoussy,
            resultadoPedGustaveRoussy: cuidadosPaliativosRI?.resultadoPedGustaveRoussy,
            pedFPSR: cuidadosPaliativosRI?.pedFPSR,
            resultadoPedFPSR: cuidadosPaliativosRI?.resultadoPedFPSR,
            escalaNumericaDolor: cuidadosPaliativosRI?.escalaNumericaDolor,
            resultadoEscalaNumericaDolor: cuidadosPaliativosRI?.resultadoEscalaNumericaDolor,
        },
        cuidadosPaliativos3: {
            idCuidadosPaliativosRI: cuidadosPaliativosRI?.idCuidadosPaliativosRI,
            viveSolo: cuidadosPaliativosRI?.viveSolo,
            cuidadoresContratados: cuidadosPaliativosRI?.cuidadoresContratados,
            claudicacionFamiliar: cuidadosPaliativosRI?.claudicacionFamiliar,
            datosSocioEcoFamiliares: cuidadosPaliativosRI?.datosSocioEcoFamiliares,
            idComboRIValorPoseeInfDiagnostica: cuidadosPaliativosRI?.idComboRIValorPoseeInfDiagnostica,
            idComboRIValorPoseeInfPronostico: cuidadosPaliativosRI?.idComboRIValorPoseeInfPronostico,
            idComboRIValorPoseeInfEnfermedad: cuidadosPaliativosRI?.idComboRIValorPoseeInfEnfermedad,
            idComboRIValorNombraPalabraCancer: cuidadosPaliativosRI?.idComboRIValorNombraPalabraCancer,
            idComboRIValorCercoDeSilencio: cuidadosPaliativosRI?.idComboRIValorCercoDeSilencio,
            idComboRIValorTrastornoAdaptacion: cuidadosPaliativosRI?.idComboRIValorTrastornoAdaptacion,
            otrosDatosInformacion: cuidadosPaliativosRI?.otrosDatosInformacion,
            cPMedicacionDosificacionRI: cuidadosPaliativosRI?.cPMedicacionDosificacionRI.map((cpMed) => cpMed.descripcion),
            problemaFisico: cuidadosPaliativosRI?.problemaFisico,
            problemaPsicologico: cuidadosPaliativosRI?.problemaPsicologico,
            problemaSocial: cuidadosPaliativosRI?.problemaSocial,
            problemaEspiritual: cuidadosPaliativosRI?.problemaEspiritual,
            otrasIndicaciones: cuidadosPaliativosRI?.otrasIndicaciones,
        }
    }
}